import firebase from 'firebase/app';
import 'firebase/messaging';
// import { initializeApp } from 'firebase/app';
// import { getMessaging } from "firebase/messaging";
// import firebase from 'firebase';

import 'firebase/auth';
import 'firebase/database';

// require('firebase/firestore');
import 'firebase/firestore';
import 'firebase/storage';


const firebaseConfig = {
  apiKey: "AIzaSyATi5dFAjcKUvby5Dokwe2eVQbTA6JqJAw",
  authDomain: "facts-skymat.firebaseapp.com",
  databaseURL: "https://facts-skymat.firebaseio.com",
  projectId: "facts-skymat",
  storageBucket: "facts-skymat.appspot.com",
  messagingSenderId: "574529435174",
  appId: "1:574529435174:web:10c11b3c47bd4998af98e7"
};

// firebase.initializeApp(firebaseConfig);
let firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp(firebaseConfig);
} else {
  firebaseApp = firebase.app(); // if already initialized, use that one
}
// const messaging = firebase.messaging();
// export { messaging };

// const app = initializeApp(firebaseConfig);
// export const messaging = getMessaging(app);
export const messaging = firebase.messaging();
export const auth = firebase.auth();
export const database = firebase.database();
export const firestore = firebase.firestore();
export const storage = firebase.storage();

export default firebaseApp;
